/**
 * The old address of an integration's page; it opens the app in Apps now
 * (`/$org/apps/$appId`), so old links and notifications keep working.
 *
 * @module routes/$org.compliance.integrations_.$integrationId
 */
import { createFileRoute } from "@tanstack/react-router";

import { redirectLegacyIntegrations } from "../components/apps/legacyIntegrationsRoute";

export const Route = createFileRoute("/$org/compliance/integrations_/$integrationId")({
  beforeLoad: ({ params, location }) => redirectLegacyIntegrations(location.pathname, params.org),
});
